import React from 'react';
export function SolutionSection() {
  return <section className="w-full py-24 px-4 bg-primary/5 relative overflow-hidden" data-id="element-162">
      {/* Decorative elements */}
      <div className="absolute top-10 left-10 text-primary/20 text-6xl rotate-12" data-id="element-163">
        🧶
      </div>
      <div className="absolute bottom-10 right-10 text-primary/20 text-6xl -rotate-12" data-id="element-164">
        ✨
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-165">
        <p className="font-heading text-2xl md:text-3xl text-textLight italic mb-8" data-id="element-166">
          Por eso creé:
        </p>

        <div className="bg-white p-10 md:p-16 rounded-[2.5rem] shadow-soft-lg border border-primary/10 relative" data-id="element-167">
          {/* Top accent line */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-1.5 bg-primary rounded-b-full" data-id="element-168"></div>

          <h2 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-textDark mb-8 leading-tight" data-id="element-169">
            MÉTODO{' '}
            <span className="text-primary block mt-2" data-id="element-170">CREA CON HILOS</span>
          </h2>

          <div className="font-body text-xl md:text-2xl text-textDark leading-relaxed space-y-6 max-w-2xl mx-auto" data-id="element-171">
            <p data-id="element-172">
              Un <b data-id="element-173">sistema paso a paso</b> diseñado para que cualquier persona
              pueda aprender crochet desde cero.
            </p>
            <p data-id="element-174">
              Logra resultados reales <u data-id="element-175">sin frustrarse</u>.
            </p>
          </div>
        </div>
      </div>
    </section>;
}